import type { CreatorBadge as CreatorBadgeType } from "@coinfallsmp/shared";

/**
 * Crown is reserved exclusively for the one official CoinfallSMP account;
 * every other approved/verified creator gets the plain checkmark. Never mix
 * the two up — badge comes from creatorBadge() server-side, never chosen by
 * the frontend.
 */
export default function CreatorBadge({ badge }: { badge: CreatorBadgeType }) {
  if (badge === "official") {
    return (
      <span className="creator-badge creator-badge-official" title="Official CoinfallSMP account">
        👑
      </span>
    );
  }
  if (badge === "verified") {
    return (
      <span className="creator-badge creator-badge-verified" title="Approved creator">
        ✓
      </span>
    );
  }
  return null;
}
